import { range } from 'lodash';
import moment from 'moment';

import * as OvationsApi from 'core/ovations-api';
import { AppeasementResponsibility, AppeasementState, RewardPackageType } from 'core/ovations-api/enums';
import mockCustomer from './customer';
import { mockPlatformUser } from './history';
import { mockPromotionSummary } from './promotion';

export const mockAppeasementDetailList: OvationsApi.Types.AppeasementDetail[] = range(1, 51).map((i) => ({
    id: String(i),
    number: i,
    customer: mockCustomer,
    programId: `programId-${i}`,
    promotion: mockPromotionSummary,
    comment: `${i}-comment`,
    rewardAmount: i * 1.1,
    responsibility: i % 2 === 0 ? AppeasementResponsibility.Client : AppeasementResponsibility.GroupO,
    appeasementState: Object.keys(AppeasementState)[i % 5] as AppeasementState,
    attachments: [],
    createDate: moment().subtract(i, 'days').toISOString(),
    createdBy: mockPlatformUser,
    reviewedBy: null,
    rewardPackageType: RewardPackageType.SingleLoadUSA,
    isAppeasementApprovalRequired: false,
}));

export const mockAppeasementDetail = mockAppeasementDetailList[0];
